module.exports = __webpack_public_path__ + "static/img/theme-1.43f7685.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/salepage/theme-1.png
// module id = 5Dva
// module chunks = 134